import { useEffect, useState, useRef } from 'react';

// Basically allows to save any plain object (containing primitives, or singular primitive) into localstorage or session storage, useage the same as in
// useState hook, so You can pretty easily substitute one for another.
//
// Local - Means that data will be available across all tabs even after restarting browser
// Session - Means that data will be available as long as tab is open (basically you can refresh page and the data is still there, but as you close the browser tab - it's lost)
//
// arg 1: default data that is going to be used
// arg 2: unique key, hook counts on this to be unique, otherwise there will be conflicts
// arg 3: optional, if true, it will use session storage instead
//
// Example using localStorage
// const [modalOpen, setModalOpen] = useStorage(false, 'unique-key-for-this-use'); // Will save and be available even after browser restart
//
// Example using session storage
// const [state, setState] = useStorage({name: '', surName: ''}, 'another-key', true); // Will save and be available in current tab until it is closed

type TypeOfUseStorage = (
  defaultValue: any,
  key: string,
  useSeesionStorageInstead?: boolean
) => [any, (argument: any) => void];

const useStorage: TypeOfUseStorage = (defaultValue, key, useSeesionStorageInstead = false) => {
  const isFirstRun = useRef(true);
  const storage = useSeesionStorageInstead ? sessionStorage : localStorage;
  const [state, setState] = useState(JSON.parse(storage.getItem(key) || defaultValue));

  useEffect(() => {
    if (!isFirstRun.current) {
      storage.setItem(key, JSON.stringify(state));
    }

    isFirstRun.current = false;
  }, [state]);

  return [state, setState];
};

export default useStorage;
